import React from 'react';
import { Modal, Table, Form, Empty, Input, Button } from 'antd';

/* import './style.css'; */

const { Search } = Input;

class SearchCreditoModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleSearch = (value) => {
/*         
        const dataSource = this.props.dataSource.filter(item => {
            return global.formatSearch(`${item.codigoReferencia} - ${item.nombre}`).match(global.formatSearch(value));
        });
        this.props.form.setFieldsValue({ dataSource }); */
    };

    render() {
     
        const { getFieldDecorator, getFieldValue } = this.props.form;
        getFieldDecorator('dataSource', { initialValue: this.props.dataSource });
        getFieldDecorator('loading', { initialValue: false });
        
        return (
            <Modal
                className='table-search-product-component'
                title={"Búsqueda de Nota de credito"}
                visible={this.props.visible}
                style={{ top: 30 }}
                width="1000px"
                onCancel={() => {
                    this.props.form.resetFields();
                    this.props.onCancel()
                }}
                footer={[
                    <Button
                        key="send"
                        type="primary"
                        onClick={() => {
                            this.props.form.resetFields();
                            this.props.onCancel()
                        }}
                    >
                        Ok
                    </Button>
                ]}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="">
                                {getFieldDecorator('codigoNombre', {
                                    initialValue: ''
                                })(
                                    <Search
                                        placeholder="Búsqueda por Código o Nombre"
                                        autoComplete="off"
                                        maxLength={100}
                                        loading={getFieldValue('loading')}
                                       // onSearch={value => this.props.validarStock ? this.props.onBuscarProducto(value) : this.handleSearch(value)}
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Table
                                rowClassName={(record, index) => 'cursor-pointer agregados'}
                                className="table-search-product-component"
                                size="small"
                                style={{ overflowX: 'auto' }}
                                rowKey={record => `${record.id}-${record.numeroLote}`}
                                dataSource={getFieldValue('dataSource')}
                                onRow={(item) => ({ onClick: () => (this.props.onSelect(item)) })}
                                locale={{
                                    emptyText: <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description="No se encontraron datos."
                                    />
                                }}
                                
                                columns={[
                                    {
                                        title: 'Fecha',
                                        dataIndex: 'fecha',
                                        key: 'fecha'
                                    },
                                    {
                                        title: 'Nro Comprobante',
                                        dataIndex: 'nroDocumento',
                                        key: 'nroDocumento'
                                    },
                                    {
                                        title: 'Moneda',
                                        dataIndex: 'moneda',
                                        key: 'moneda'
                                    },
                                    {
                                        title: 'Monto',
                                        dataIndex: 'total',
                                        key: 'total',
                                        render: (value,row,index)=>{
                                            return  <span>{value.toFixed(2) }</span>
                                        }

                                    }
                                ]}
                            />
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(SearchCreditoModal)